import { render, staticRenderFns } from "./StartupRate.vue?vue&type=template&id=269a8123&"
import script from "./StartupRate.vue?vue&type=script&lang=js&"
export * from "./StartupRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports